import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const el = document.getElementById("first-cta");
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <AnimatePresence data-id="element-37" data-mp="bpzop12vyyu0">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 bg-plum-950/95 px-3 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 backdrop-blur" data-id="element-38" data-mp="boyainqkpw82">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-xl items-center justify-center gap-2 rounded-2xl bg-cta px-4 py-3.5 font-display text-base font-extrabold uppercase text-white shadow-[0_5px_0_0_#14532d] hover:bg-cta-dark sm:text-lg" data-id="element-39" data-mp="2f2r2poj4ftkl">
            Get the Blueprint — Only $27
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-40" data-mp="1wdj8ubcyua6x" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}